import { Chart, CategoryScale, LinearScale, BarElement, Tooltip, type ChartConfiguration } from "chart.js"
import { Bar } from "react-chartjs-2"

Chart.register(CategoryScale, LinearScale, BarElement, Tooltip)

const defaultColors = ["#3b82f6", "#22c55e", "#ef4444"]

export const HorizontalBar = ({ data }: Pick<ChartConfiguration<"bar">, "data">) => {
  const coloredData = {
    ...data,
    datasets: data.datasets.map((ds) => {
      const barCount = Array.isArray(ds.data) ? ds.data.length : defaultColors.length
      return {
        ...ds,
        backgroundColor: Array.from({ length: barCount }, (_, i) => defaultColors[i % defaultColors.length]),
        borderRadius: 4,
      }
    }),
  }

  return (
    <Bar
      data={coloredData}
      options={{
        indexAxis: "y",
        animation: { duration: 0 },
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { display: false },
          tooltip: { enabled: true },
        },
        scales: {
          x: { beginAtZero: true },
        },
      }}
      className="h-full w-full"
    />
  )
}
